import React, { useState, useEffect, useRef, useImperativeHandle,forwardRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ChatService from '../../services/ChatService';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import useApi from '../../api/useApi';
import useAuth from '../../context/useAuth';
import useQueryParams from '../../context/useQueryParams';
import { NumericFormat } from 'react-number-format';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const PaymentDetails = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [lotSummary, setLotSummary] = useState({});
    const lotSummaryRef = React.useRef(lotSummary);
    const [lotDetailsData, setLotDetailsData] = useState([]);
    const api = useApi();
    const { auth } = useAuth();
    const { setParameters } = useQueryParams();
    const [role] = useState(auth?.role?.toLowerCase());
    const gridApi = React.useRef(null);
    const [traderwiseReport, setTraderwiseReport] = useState([]);
    const [lotwiseReport, setLotwiseReport] = useState([]);
    const [lotwiseModalVisible, setLotwiseModalVisible] = useState(false);
    const [traderwiseModalVisible, setTraderwiseModalVisible] = useState(false);
    const [lotwiseGridApi, setlotwiseGridApi] = useState(null);
    const [traderwiseGridApi, setTraderwiseGridApi] = useState(null);
    const scrollTop = useRef(0);
    const CustomTextAreaEditor = forwardRef((props, ref) => {
        const inputRef = useRef();

        useImperativeHandle(ref, () => ({
            getValue() {
                return inputRef.current.value;
            },
            // Optional: Focus the textarea on open
            afterGuiAttached() {
                inputRef.current.focus();
            },
        }));

        return (
            <textarea
                ref={inputRef}
                defaultValue={props.value}
                style={{ width: '100%', height: '100%', whiteSpace: 'pre-wrap', overflowWrap: 'break-word', border: 'none', backgroundColor: 'transparent', color: 'black' }}
            />
        );
    });


    const handleCellValueChanged = (params) => {
        // Extract the updated data from the grid
        const updatedData = lotDetailsData.map((row) =>
            row.lotId === params.data.lotId ? { ...row, [params.colDef.field]: params.newValue } : row
        );

        // Update the state with the new data
        setLotDetailsData(updatedData);

        // You can also perform additional actions with the updated data
    };

    const totalValueRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        const buttonClicked = () => {
            alert(`${cellValue} medals won!`);
        };

        return (
            <span>
                <span>{cellValue}</span>
                <br></br>
                <button className="btn btn-sm ripple btn-outline-primary fs-11 mg-t-5" onClick={() => buttonClicked()}>Lot Detail</button>
            </span>
        );
    };

    const linkRenderer = (props) => {

        const planterOrDealer = (props.node.data.planterDealer === '1' ? "P" : (props.node.data.planterDealer === '2' ? "D" : props.node.data.planterDealer));
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value + ' (' + planterOrDealer + ')';

        return (
            <span>
                <span role="button"  >
                    <div className="d-flex flex-column cell-val">
                        <div>{cellValue}</div>
                        <div>Qty (Kg) :  <strong>{props.node.data.quantityKg}</strong></div>
                        <div>No of Bags :  <strong>{props.node.data.bags}</strong></div>
                        <div>Litre Weight (gm) :  <strong>{props.node.data.litreWeightGms}</strong></div>
                        <div>Status :  <strong>{props.node.data.statusName}</strong></div>  
                        <div>Buyer :  <strong>{props.node.data.buyerName}</strong></div>  
                        <div></div>
                    </div>
                    
                </span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };
    const statusRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span className="has-withdraw-btn">
                <span>{cellValue}
                    {/*onClick={() => viewPoolingDetail(auctionId)}*/}
                    {props.node.data.status === 8 ?
                        <div className="after-sold-withdraw-btn">
                            <button className="btn ripple btn-outline-danger mg-l-10 btn-sm" type="button" >
                                Withdraw
                            </button>
                        </div> : null}
                </span>
            </span>
        );
    };

    const columns = [
        {
            headerName: 'Lot No.', field: 'lotNumber', cellClass: 'text-center', width: 60, pinned: 'left'
        },
        {
            headerName: 'Name of the Grower (Planter / Dealer)',
            field: 'planterName', flex: 1, minWidth: 280, wrapText: true, autoHeight: true,
            cellRenderer: linkRenderer
        },
        { headerName: 'Sale Price (₹)', field: 'finalPrice', width: 100, cellClass: "text-center", autoHeight: true },
        { headerName: 'Sample Refund Amount (for 2850gms) ', field: 'sampleRefundAmount', width: 100, cellClass: "text-center", autoHeight: true },
        { headerName: 'Commission Charges', field: 'commissionCharges', width: 100, cellClass:"highlight-light text-center", autoHeight: true, editable:true },
        { headerName: 'GST on Commission Charges', field: 'gstOnCommission', cellClass: "highlight-light text-center", width: 150, autoHeight: true, editable: true },
        { headerName: 'Total Amount Paid to the Planter / Dealer', field: 'totalAmountPaid', cellClass: "highlight-light text-center", width: 150, autoHeight: true, editable: true },
        { headerName: 'Transaction Details', field: 'transactionDetails', width: 200, cellEditor: CustomTextAreaEditor, cellClass: "highlight-light", autoHeight: true, wrapText:true, editable: true },
        //{ headerName: ' ', field: row => <button cellclassName="btn ripple btn-outline-primary text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => viewLotDetails(row.lotId)}> <i cellclassName="fe fe-edit-2"></i> Detail</button> },
    ];

    const gridOptions = {

        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowClass: 'custom-grid-font',
        //getRowClass: params => {
        //    if (params.node.data.status === 8) {
        //        return 'bg-lot-completed';
        //    }
        //    else if (params.node.data.status === 6) {
        //        return 'bg-lot-withdrawn';
        //    }
        //    else if (params.node.data.status >= 1 && params.node.data.status <= 5) {
        //        return 'bg-lot-inprogress';
        //    }
        //    else if (params.node.data.status === 7) {
        //        return 'bg-lot-skip';
        //    }
        //},
        columnDefs: columns,
    };

    const fetchDataFromApi = async () => {
        try {
            let lotData = await api.getPaymentDetails(id);
            setLotDetailsData(lotData);

        } catch (error) {
            alert('Unable to fetch lot detail data.');
        }
    };

    useEffect(() => {
        fetchDataFromApi();
    }, []);


    const getRowStyle = params => {
        //if (params.node.rowIndex % 2 === 0) {
        return { background: '#fff' };
        //}
    };

    const viewLotDetails = (auctionId, lotNo) => {
        if (lotSummaryRef.current.auctionStatus !== 2) {
            setParameters(prev => ({ ...prev, initialJumpToLotNo: lotNo }));
            //setParameters({ initialJumpToLotNo : lotNo })
            navigate(`/auctioneerLotDetails/${auctionId}`);
        }
        else
            alert("Action not allowed. This auction is already closed.");
    };

    const onCellEditingStarted = (event) => {
        //if (lotSummary.auctionStatus === 2) {
        //    const api = gridApi.current;
        //    if (api) {
        //        api.stopEditing(true);
        //    }
        //}
    };

    const savePaymentDetail = async () => {

        if (gridApi.current ) {
            gridApi.current.api.stopEditing();
        }

        const lotPriceData = lotDetailsData.map(t => {
            return {
                lotId: t.lotId,
                auctionId: t.auctionId,
                commissionCharges: t.commissionCharges,
                gstOnCommission: t.gstOnCommission,
                totalAmountPaid: t.totalAmountPaid,
                transactionDetails: t.transactionDetails,
            }
        })

        await api.savePaymentDetails(lotPriceData)
            .then((response) => {
                if (response.success) {
                    fetchDataFromApi();
                    alert(response.message);
                }
                else
                    alert(response.message);
            })
            .catch((error) => {
                console.error('Error saving lot price data:', error);
            });
    };

  

    const exportLotwiseReport = async () => {

        try {
            const { fileName, fileData } = await api.downloadReport('AuctioneerLotWise', parseInt(id));
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }

       
    };

    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Payment Details</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" onClick={() => navigate('/auctioneer')}>Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page" >Payment Details</li>
                        </ol>
                    </div>
                    {/*<div className="d-flex">*/}
                    {/*    <div className="justify-content-center">*/}
                    {/*        <button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" >*/}
                    {/*            <i class="ti ti-import me-2"></i>Export to csv*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between">
                                    <div className="btn-list mg-b-5">
                                        <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={() => navigate('/auctioneer')}><i class="ti ti-arrow-left me-2"></i>Back</button>
                                    </div>
                                        <div className="btn-list mg-b-5">
                                            <button className="btn btn-sm ripple btn-primary fs-11" onClick={savePaymentDetail}>Submit</button>
                                        </div> 
                                </div>
                                <div>



                                    <div
                                        style={{ height: 500 }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >

                                        <AgGridReact
                                            className="paymentDetailGrid"
                                            deltaRowDataMode={true}
                                            suppressScrollOnNewData={true}
                                            gridOptions={gridOptions}
                                            rowData={lotDetailsData}
                                            getRowStyle={getRowStyle}
                                            onGridReady={(params) => (gridApi.current = params)}
                                            onCellEditingStarted={onCellEditingStarted}
                                            onCellValueChanged={handleCellValueChanged}
                                        />


                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
        </div>
    );
}

export default PaymentDetails;